import React, { forwardRef } from 'react';
import Barcode from 'react-barcode';
import '../../CSS/Invoice.css';
import moment from 'moment';

const RefundSlip = forwardRef(({ user, invoiceData, returnList, returnTotal, getDiscountPercentage }, ref) => {
    const today = new Date();
    const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();

    return (
        <div ref={ref} style={{ paddingLeft: '35px', paddingRight: '35px' }} className='invoice-print'>
            <div className="invoice-pharmacy-details d-flex justify-content-center">
                <div className="text-center">
                    <h5>{user?.organization?.name}</h5>
                    <p>Location : {user?.organization?.address}</p>
                    <p>Tel : {user?.organization?.mobile}</p>
                    <h6 className="mt-2" style={{ color: '#d33' }}>REFUND SLIP</h6>
                </div>
            </div>
            <div className="invoice-date invoice-border-dashed">
                {invoiceData?.member_name && (
                    <div>
                        <p>Member Name: {invoiceData?.member_name}</p>
                        <p>Phone Number: {invoiceData?.member_phone}</p>
                    </div>
                )}
                <div className='d-flex justify-content-between'>
                    <div>
                        <p>Sales Person : {user?.name}</p>
                        <p>Date : {new Date().toLocaleDateString('en-GB')}</p>
                    </div>
                    <div>
                        <p style={{ textAlign: 'end' }}>Ref Invoice : {invoiceData?.invoice_no}</p>
                        <p style={{ textAlign: 'end' }}>Time : {moment(time, 'HH:mm:ss').format('hh:mm A')}</p>
                    </div>
                </div>
            </div>
            <div className="invoice-item-table">
                <table>
                    <tr className='invoice-border-dashed'>
                        <td width={'51%'}>Item</td>
                        <td width={'15%'} className='text-right'>Qty</td>
                        <td width={'20%'} className='text-right'>Price</td>
                        <td width={'15%'} className='text-right'>Amount</td>
                    </tr>
                    {returnList.filter(item => parseInt(item.qty) > 0).map((item, i) => (
                        <tr key={i}>
                            <td width={"51%"}>{item.name}</td>
                            <td width={"15%"} className='text-start'>{parseInt(item.qty)}</td>
                            <td width={"20%"} className='text-start'>{parseFloat(item.price).toFixed(2)}</td>
                            <td width={"15%"} className='text-end'>{(parseInt(item.qty) * parseFloat(item.price)).toFixed(2)}</td>
                        </tr>
                    ))}
                    <tr className='invoice-border-dashed-top'>
                        <td colSpan={3} className='text-end fw-bolder'>Sub Total : </td>
                        <td className='text-end'>
                            {returnList.reduce((a, b) => a + parseFloat(b.qty || 0) * parseFloat(b.price || 0), 0).toFixed(2)}
                        </td>
                    </tr>
                    {parseFloat(getDiscountPercentage) > 0 && (
                        <tr>
                            <td colSpan={3} className='text-end'>Discount ({getDiscountPercentage}%) : </td>
                            <td className='text-end'>
                                {(returnList.reduce((a, b) => a + parseFloat(b.qty || 0) * parseFloat(b.price || 0), 0) * parseFloat(getDiscountPercentage) / 100).toFixed(2)}
                            </td>
                        </tr>
                    )}
                    <tr className='invoice-border-dashed-top'>
                        <td colSpan={3} className='text-end fw-bold' style={{ color: '#d33' }}>Refund Total : </td>
                        <td className='text-end fw-bold' style={{ color: '#d33' }}>{returnTotal.toFixed(2)}</td>
                    </tr>
                </table>
            </div>
            <div className="invoice-creator mt-1">
                <p>Processed By: {user?.name}</p>
            </div>
            <div className='row mt-3'>
                <p className='border-bottom w-50 mt-2 fw-bold'>Terms & Condition:</p>
                <p>১. ক্যাশ মেমো ছাড়া ওষুধ ফেরত নেওয়া হয় না ।</p>
                <p>২. বিক্রিত ওষুধ ৭ দিন পর ফেরত নেওয়া হয় না ।</p>
                <p>৩. ইনসুলিন ও বিদেশী ওষুধ ফেরত নেওয়া হয় না ।</p>
                <p>৪. বিক্রিত ওষুধ এর টাকা ফেরত দেওয়া হয় না  ।</p>
                <p>৫. কাটা ছেড়া ও ফ্রিজের বিক্রিত ওষুধ ফেরত নেওয়া হয় না ।</p>
            </div>
            <div className="branding-section mt-3 mx-auto text-center">
                <p>Software and services developed by MacroHealthPlus, your trusted technology partner.</p>
            </div>
            <div className="invoice-greeting d-flex justify-content-center align-items-center mt-1">
                <Barcode displayValue={false} height={40} width={3} value={invoiceData?.invoice_no || 'N/A'} />
            </div>
            <div className="d-flex justify-content-center branding-section">
                <p>Thank You</p>
            </div>
        </div>
    );
});

RefundSlip.displayName = 'RefundSlip';

export default RefundSlip;
